import React, { memo } from 'react';
import styled from 'styled-components';
import {
  TypographyComponent as TypographyElement,
  MarketingCard as MarketingCardComponent,
  SpanLink,
  BrandLogos,
} from '@tvg/fuse-design';

import CardButton from 'components/CardButton/CardButton';
import { PromotionVoucher } from 'types/Product';
import analyticsEvent from '../../../services/analytic/analytic-service';

const StyledMarketingCard = styled(MarketingCardComponent)`
  margin-bottom: var(--spacing-space24);
  padding: 0;
`;

const IconContainer = styled.span`
  margin-bottom: var(--spacing-space16);
`;

const StyledCardButton = styled(CardButton)`
  padding: var(--spacing-space16);

  > * {
    display: block;
  }
`;
const Description = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
`;

interface PromotionVoucherCardProps {
  promotionVoucher: PromotionVoucher;
  openDialog: () => void;
}

const PromotionVoucherCard = memo(({ promotionVoucher, openDialog }: PromotionVoucherCardProps) => {
  const onClickHandler = () => {
    openDialog();

    analyticsEvent({
      gaAction: 'Product Page - Promotion voucher',
      gaLabel: `${promotionVoucher.type} moreinfo`,
    });
  };

  return (
    <StyledMarketingCard data-testid="promotion-voucher-card">
      <StyledCardButton onClick={onClickHandler}>
        <IconContainer>
          <BrandLogos brand="VeryPay" width={96} alt="Very Pay" dataTestId="promotion-voucher-icon" />
        </IconContainer>
        <Description size="2" tag="span">
          {promotionVoucher?.cardDescription}
        </Description>
        <SpanLink>Learn more</SpanLink>
      </StyledCardButton>
    </StyledMarketingCard>
  );
});

export default PromotionVoucherCard;
